import React, { useState, useEffect } from "react";
import SideMenu from "../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import "../../Dashboard.css";
import DocumentScannerSharpIcon from "@mui/icons-material/DocumentScannerSharp";
import FormatQuoteSharpIcon from "@mui/icons-material/FormatQuoteSharp";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import BusinessIcon from "@mui/icons-material/Business";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import Modal from "@mui/material/Modal";
import CircularIndeterminate from "../../../GeneralComponents/CirularProgress";
import StyledDataGrid from "../../../GeneralComponents/StyledDataGrid";
import "../../../../../assets/css/DG.css";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Cookies from "universal-cookie";
import { useGlobalContext } from "../../../../../context";
import UpdateIncomeTaxReport from "./UpdateIncomeTaxReport";
import ViewIncomeTaxReport from "./ViewIncomeTaxReport";
import { FrontEndDomain } from "../../../../../assets/js/Host";
import FilterListIcon from '@mui/icons-material/FilterList';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import FullScreenDialog from "../../../GeneralComponents/FullScreenDialog";
import Popover from '@mui/material/Popover';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import FormHelperText from '@mui/material/FormHelperText';

import {format} from 'date-fns'
import { from } from "stylis";
import axios from "axios";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  width: "90%",
  height: "90%",
  overflowY: "scroll",
  paddingBottom: "10px",
  border: "none",
  outline: "none",
  borderRadius: "15px",
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function IncomeTaxReportDataGrid(props) {
  const [inactive, setInactive] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [incomeTaxReportTotal, setIncomeTaxReportTotal] = useState(0);
  const [incomeTaxReportNumberOfPages, setIncomeTaxReportNumberOfPages] =
    useState(0);
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const {incomeTaxReports,stages, fetchData } = useGlobalContext();
  // Normalize stages to an array whether it's already an array or a paginated object
  const stagesList = Array.isArray(stages) ? stages : (stages && Array.isArray(stages.data) ? stages.data : []);
  const [activFilter,setActiveFilter]=useState(false)
const [open1,setOpen1]=useState(false);
const [open2,setOpen2]=useState(false);

const [fromDate,setFromDate]=useState(null)
const [toDate,setToDate]=useState(null)
const [folderNumber,setFolderNumber]=useState(null)
const [TaxPayerName,setTaxPayerName]=useState(null)
const [groupName,setGroupname]=useState(null)
const [careerName,setCareerName]=useState(null)
const [createDate,setCreateDate]=useState(null)
const [loading,setLoading]=useState(false)
const [render,setRender]=useState(false)
const [nameOfRejeted,setNameOfReject]=useState([])
const [stageSelected,setStageSelected]=useState({})

const [anchorEl, setAnchorEl] = React.useState(null);

const handleClick = (event,status) => {
  if(status==3)
  setAnchorEl(event.currentTarget);
};

const handleClose = () => {
  setAnchorEl(null);
};

const open = Boolean(anchorEl);
const id = open ? 'simple-popover' : undefined;

  const [columns] = useState([
    { field: "id", headerName: "ت", width: 50 },

    {
      field: "folder_number",
      headerName: "رقم الاضبارة",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {rows?.row?.folder_number}
          </Typography>
        );
      },
    },
    {
      field: "tax_payer_name",
      headerName: "الاسم الكامل",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {rows?.row?.tax_payer_name}
          </Typography>
        );
      },
    },
    {
      field: "groups_carriers",
      headerName: "المجموعة",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {rows?.row?.groups_carrier?.name}
          </Typography>
        );
      },
    },
    {
      field: "carrier",
      headerName: "المهنة",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {rows?.row?.carrier?.name}
          </Typography>
        );
      },
    },
    {
      field: "created_at",
      headerName: "تاريخ الانشاء",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {moment(rows?.row?.created_at).format("DD/MM/YYYY")}
          </Typography>
        );
      },
    },
    {
      field: "stage_transaction_type_now",
      headerName: "المرحلة الحالية",
      flex: 1,
      renderCell: (rows) => {
        return (
          <Typography sx={{ whiteSpace: "normal" }}>
            {rows?.row?.transactions?.stage_transaction_type?.stage?.name}
          </Typography>
        );
      },
    },
    {
      field: "status_now",
      headerName: "الحالة",
      flex: 1,
      renderCell: (rows) => {
          let status=getStatusOfCurrentStage(rows?.row)
        return (
          <div>
          <Typography sx={{ whiteSpace: "normal",backgroundColor:status==2?'green':status==1?'orange':status==3?'red':'grey',color:'white',padding:'4px 8px',borderRadius:'20px' }}  onClick={(e)=>handleClick(e,status)}
          >
            {status==2?'اكتملت':status==1?'قيد الانتظار':status==3?'رفضت':""}
          </Typography>

          
          </div>
        );
      },
    },

    {
      field: "actions",
      width: 200,
      headerName: "الادوات",
      renderCell: (rows) => (
        <strong>
          {/* {
            cookies.get("role_id") == 3 || cookies.get("role_id") == 0?
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label={
              cookies.get("role_id") == 3 || cookies.get("role_id") == 0
                ? "تحديد صنف النشاط"
                : "ليس لديك صلاحية للوصول لهذه الصفحة"
            }
            size="small"
            onClick={() => {
              if (cookies.get("role_id") == 3 || cookies.get("role_id") == 0)
                window.open(
                  FrontEndDomain + `income_estimate_class?id=${rows?.row?.id}`,
                  "_blank"
                );
            }}
          >
            <Tooltip
              title={
                cookies.get("role_id") == 3 || cookies.get("role_id") == 0
                  ? "تحديد صنف النشاط"
                  : "ليس لديك صلاحية للوصول لهذه الصفحة"
              }
            >
              <FontDownloadIcon style={{ fill: "#318eeb" }} />
            </Tooltip>
          </IconButton>:null
         }
         {
          cookies.get("role_id") == 3 || cookies.get("role_id") == 0?
         
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label={
              cookies.get("role_id") == 3 || cookies.get("role_id") == 0
                ? "مقتبسات وتصاريح"
                : "ليس لديك صلاحية للوصول لهذه الصفحة"
            }
            size="small"
            onClick={() => {
              if (cookies.get("role_id") == 3 || cookies.get("role_id") == 0)
                window.open(
                  FrontEndDomain + `other_business?id=${rows?.row?.id}`,
                  "_blank"
                );
            }}
          >
            <Tooltip
              title={
                cookies.get("role_id") == 3 || cookies.get("role_id") == 0
                  ? "مقتبسات وتصاريح"
                  : "ليس لديك صلاحية للوصول لهذه الصفحة"
              }
            >
              <FormatQuoteSharpIcon style={{ fill: "#318eeb" }} />
            </Tooltip>
          </IconButton>:null
          }
          {
              cookies.get("role_id") != 5?
          
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label={
              cookies.get("role_id") != 5
                ? "مذكرة التخمين"
                : "ليس لديك الصلاحية للوصول لهذه الصفحة"
            }
            size="small"
            onClick={() => {
              if (cookies.get("role_id") != 5)
                window.open(
                  FrontEndDomain + `income_estimate_form?id=${rows?.row?.id}`,
                  "_blank"
                );
            }}
          >
            <Tooltip
              title={
                cookies.get("role_id") != 5
                  ? "مذكرة التخمين"
                  : "ليس لديك الصلاحية للوصول لهذه الصفحة"
              }
            >
              <DocumentScannerSharpIcon style={{ fill: "#318eeb" }} />
            </Tooltip>
          </IconButton>:null
          } */}
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="عرض"
            size="small"
            onClick={() => {
              viewObject(rows.row);
            }}
          >
            <Tooltip title="View">
              <RemoveRedEyeRoundedIcon color="#2E5266" />
            </Tooltip>
          </IconButton>

          {/* <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row);
            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              //TODO delete object
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton> */}
        </strong>
      ),
    },
  ]);





  const getStatusOfCurrentStage=(data)=>{
    
       let check=false;
        data?.transactions?.transaction_type?.stage_transaction_type?.map((stageTraType)=>{
          if(data?.transactions?.stage_transaction_type?.id==stageTraType?.id){
            
              let arr_2={}
              let count_check=0;
              let count_check_tow=0;
              let count_check_rejected=0;

              let status=false;
              stageTraType?.transaction_approval?.map((approv)=>{
                    if(data?.transactions?.id==approv?.transaction_id){
                      if(approv?.approval_status?.id==2||approv?.stage_transaction_type_approval?.is_mandatory==0){
                        count_check++;
                      }
                      if(approv?.approval_status?.id==3&&approv?.stage_transaction_type_approval?.is_mandatory==1){
                        count_check_rejected++;
                      }
                      count_check_tow++
                  }
              })


              if(count_check==count_check_tow&&count_check==stageTraType?.stage_transaction_type_approval?.length){
                status=2;
              }

              if(stageTraType?.stage_transaction_type_approval?.length==0){
                status=1;
              }

              if(count_check_rejected>0){
                status=3
              }else if(status ==false){
                status=1
              }

              check= status
        }

    })

 
    

    return check
  }

  const [rows, setRow] = useState([]);
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1);
  };

  const updateObject = async (object) => {
    setSelectedObject(object);

    setshowBoxOfEditForm(true);
  };
  const viewObject = async (object) => {
    setSelectedObject(object);
    setshowBoxOfViewForm(true);
  };
  const advanceSearch = () => {
    fetchData("INCOME_TAX_REPORT", "income_tax_report", {
      page: pageNumber,
      page_size: pageSize,
    });

    fetchData("STAGES", "stages_list", {});
  };
  useEffect(() => {
    advanceSearch();
  }, [pageSize, pageNumber,]);
  //Reformatting incomeTaxReport object once incomeTaxReport are loaded
  useEffect(() => {
    if (
      incomeTaxReports &&
      incomeTaxReports.data &&
      incomeTaxReports.data.length > 0
    ) {
      setRow(incomeTaxReports.data);
      setIncomeTaxReportTotal(incomeTaxReports.total);
      setIncomeTaxReportNumberOfPages(incomeTaxReports.last_page);

    
        let check=false;
        let arr_rej=[]
        incomeTaxReports.data?.map((data)=>{
          data?.transactions?.transaction_type?.stage_transaction_type?.map((stageTraType)=>{
            if(data?.transactions?.stage_transaction_type?.id==stageTraType?.id){
              
                //  let arr_2={}
                //  let count_check=0;
                //  let count_check_tow=0;
                //  let count_check_rejected=0;
  
                //  let status=false;
                stageTraType?.transaction_approval?.map((approv)=>{
                      if(data?.transactions?.id==approv?.transaction_id){
                      
                        if(approv?.approval_status?.id==3&&approv?.stage_transaction_type_approval?.is_mandatory==1){
                          //  count_check_rejected++;
                          console.log('name',approv?.stage_transaction_type_approval?.role?.name)

                          arr_rej.push({
                            id:approv?.stage_transaction_type_approval?.role?.id,
                            name:approv?.stage_transaction_type_approval?.role?.name,
  
                          })
                        }
                    }
                })
  
                
              
  
          }
  
          })
        })
        setNameOfReject(arr_rej)

 
    }
  }, [incomeTaxReports?.data]);

  useEffect(()=>{
     console.log('name',nameOfRejeted)
  },[nameOfRejeted])

  useEffect(()=>{
    const viewBtn = document.querySelector(".FormContainer2");
    const  popup = document.querySelector(".popup");
    const close = popup.querySelector(".close");
      // field = popup.querySelector(".field"),
      // input = field.querySelector("input"),
      // copy = field.querySelector("button");

    viewBtn.onclick = ()=>{
      popup.classList.toggle("show");
      setActiveFilter(true)
    }
    close.onclick = ()=>{
      popup.classList.toggle("show");
      setActiveFilter(false)
      
    }


  },[])

  const getFilteredData=async()=>{
    setLoading(true)
    let data=null;
    let FormData={
      
      from: fromDate?formatDate_now(fromDate):null,
      to:toDate?formatDate_now(toDate):null,
      folder_number:folderNumber,
      tax_payer_name:TaxPayerName,
      group_name:groupName,
      career_name:careerName,
      created_date: createDate?formatDate_now(createDate):null,
      stageSelected_id:stageSelected?.id
    }
    try{
      data=await axios({
        method:'post',
        url:ApiSetting.apiUrl+'/income_tax_report/getFilteredData',
        data:FormData,
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json',
          "X-localization": language

        }
      })
      if(data){
        
         if(data.data.status==200){
          if (
            data.data.data &&
            data.data.data.data &&
            data.data.data.data.length > 0
          ) {
            setRow(data.data.data.data);
            setIncomeTaxReportTotal(data.data.data.total);
            setIncomeTaxReportNumberOfPages(data.data.data.last_page);
            setStageSelected({})
            setFromDate(null)
            setToDate(null)
            setFolderNumber(null)
            setTaxPayerName(null)
            setGroupname('')
            setCareerName('')
            setCreateDate(null)
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "success",
              message: data.data.message,
            });
            document.querySelector(".popup").classList.toggle('show')
            setActiveFilter(false)
          }
         }else{
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
         }
    setLoading(false)

      }
    }catch(err){
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
    setLoading(false)

    }
  }

  const formatDate_now = (date) => {
    let y = date.getFullYear();

    let m = date.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let d = date.getDate();
    if (d < 10) d = "0" + d;

    return y + "-" + m + "-" + d;
  };
  // Safely normalize a date value (Date, ISO string, or dd/MM/yyyy) to a valid Date or null
  const normalizeDate = (d) => {
    if (!d) return null;
    if (d instanceof Date && !isNaN(d.getTime())) return d;
    if (typeof d === 'string') {
      // yyyy-MM-dd
      if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
        const dt = new Date(Number(d.slice(0,4)), Number(d.slice(5,7)) - 1, Number(d.slice(8,10)));
        return isNaN(dt.getTime()) ? null : dt;
      }
      // dd/MM/yyyy
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(d)) {
        const [dd, mm, yyyy] = d.split('/');
        const dt = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        return isNaN(dt.getTime()) ? null : dt;
      }
      // Fallback parse
      const dt = new Date(d);
      return isNaN(dt.getTime()) ? null : dt;
    }
    return null;
  };
  const changeStage=(e)=>{
    console.log('stage id=>',e.target.value)
    let stage=null;
    stagesList?.map((data)=>{
          if(data?.id==e.target.value){
           console.log('stage id=>',e.target.value,'stage',data)

            stage=data;
          }
    })
      setStageSelected(stage)
  }

  return (
    <div className="Dashboard_MOF px-0 mx-0 " >
      <div className="container-fluid w-100 mx-0 px-0" style={{overflow: 'hidden'}}>
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm" >
            <div
              className={`FormContainer  ${
                props.inactive === false ? "activeSideMenu" : ""
              }`}
              style={{
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
            >
              {/* snack alert box here ... */}
              <Snackbar
                open={snackBar.open}
                autoHideDuration={6000}
                onClose={() => {
                  setsnackBar({ ...snackBar, open: false });
                }}
                anchorOrigin={{
                  vertical: snackBar.vertical,
                  horizontal: snackBar.horizontal,
                }}
              >
                <Alert
                  onClose={() => {
                    setsnackBar({ ...snackBar, open: false });
                  }}
                  severity={snackBar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackBar.message}
                </Alert>
              </Snackbar>
            </div>

            <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            sx={{height:'400px'}}
          >
            <Typography sx={{ p: 2 }}>تم رفض الموافقة على هذه المرحلة من قبل</Typography>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {
                nameOfRejeted?.map((data)=>(
                  <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <Avatar alt="Remy Sharp" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOALqcMjby_cOSIr-3GFWRO_zY_j0qcB4zRA&usqp=CAU" />
                      </ListItemAvatar>
                      <ListItemText
                        primary={`@${data?.name}`}
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: 'inline' }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              {data?.name}
                            </Typography>
                            {" — لقد قام هذا المسئول باايقاف هذه المرحة"}
                          </React.Fragment>
                        }
                      />
                  </ListItem>
                ))
              }
            </List>
            </Popover>

            <div className={`FormContainer1  ${
                props.inactive === false ? "activeSideMenu" : ""
              }`} style={{display:"flex",justifyContent:'flex-start',width: props.inactive === false ?'100%':'85%',backgroundColor:'transparent',transition:'all 0.8s ease'}}>
                <FilterListIcon title="فلترة البيانات" className=" FormContainer2 FormContainer" style={{background:'rgb(255,255,255)',margin:'0',cursor:'pointer',fontSize:"35px",borderRadius:'4px'}}/>
            </div>

            {/* empty blur background  */}
            <div className={`filterContainer ${activFilter?'d-block':'d-none'}`} style={{width:'100vw', height:'100vh',overflow:'hidden'}} onClick={()=>{
              document.querySelector(".popup").classList.toggle('show')
              setActiveFilter(false)
            }}>
            </div>

             {/* modal for filter  */}
            <div className="popup" style={{overflow: 'hidden'}}>
              <header>
                <span>فلترة البيانات</span>
                <div className="close"><i class="uil uil-times"></i></div>
              </header>

              <div className="content">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    // border: "1px solid",
                    // borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="firstPoint" onClick={()=>{setOpen1(true)}}>
                          
                    <FormControl fullWidth className=" "  style={{zIndex:'2010'}}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}  style={{zIndex:'2010'}}>
                        <DesktopDatePicker
                          style={{zIndex:'02010',position:'absolute',top:'50%',left:'50%',transform:'translate(-50%.-50%)'}}
                          open={open1}
                          onOpen={() => setOpen1(true)}
                          onClose={() => setOpen1(false)}
                          label="من"
                          inputFormat="dd/MM/yyyy"
                          className="borderOutline"
                          value={normalizeDate(fromDate)}
                          onChange={(date) => {
                            setFromDate(date instanceof Date && !isNaN(date.getTime()) ? date : null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputProps={{ disableUnderline: "true" }}
                              className="borderOutline"
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                    </div>
                    <div className="line"></div>
                    <div className="secondPoint" onClick={()=>{setOpen2(true)}}>
                      <FormControl fullWidth className="">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            open={open2}
                            onOpen={() => setOpen2(true)}
                            onClose={() => setOpen2(false)}
                            label="الى"
                            value={normalizeDate(toDate)}
                            inputFormat="dd/MM/yyyy"
                            onChange={(date) => {
                              setToDate(date instanceof Date && !isNaN(date.getTime()) ? date : null);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                  </FormControl>
                    </div>
                 

                 

                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="رقم الاضبارة"
                        variant="outlined"
                        value={folderNumber}
                        onChange={(e) => {
                          setFolderNumber(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {/* {ErrorMessage.activityTypeError} */}
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="اسم المكلف"
                        variant="outlined"
                        value={TaxPayerName}
                        onChange={(e) => {
                          setTaxPayerName(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {/* {ErrorMessage.activityTypeError} */}
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="اسم مجموعة المهن"
                        variant="outlined"
                        value={groupName}
                        onChange={(e) => {
                          setGroupname(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {/* {ErrorMessage.activityTypeError} */}
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="المهنة"
                        variant="outlined"
                        value={careerName}
                        onChange={(e) => {
                          setCareerName(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {/* {ErrorMessage.activityTypeError} */}
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      // flex: 1,
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth  style={{zIndex:'2010'}}> 
                      <LocalizationProvider dateAdapter={AdapterDateFns}  style={{zIndex:'2010'}}>
                        <DesktopDatePicker
                        style={{zIndex:'2010'}}
                          label="تاريخ"
                          inputFormat="dd/MM/yyyy"
                          value={normalizeDate(createDate)}
                          onChange={(date) => {
                            console.log(date)
                            setCreateDate(date instanceof Date && !isNaN(date.getTime()) ? date : null);
                          }}
                          renderInput={(params) => <TextField {...params}  style={{zIndex:'2010'}} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                    <Typography className="fontForError"></Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                     <FormControl sx={{width:'100%' }}>
                      <InputLabel id="demo-simple-select-helper-label">المرحلة</InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={stageSelected?.id?stageSelected?.id:null}
                        label="المرحلة"
                        onChange={changeStage}
                      >
                    {
                      stagesList?.map((stage)=>(
                        <MenuItem key={stage?.id} value={stage?.id}>{stage?.name}</MenuItem>

                      ))
                    }
                      </Select>
                    </FormControl>
                  </div>

                  
                </div>
                <div className="footer">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                    <defs>
                        <filter id="gooey">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
                            <feColorMatrix in="blur" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="highContrastGraphic" />
                            <feComposite in="SourceGraphic" in2="highContrastGraphic" operator="atop" />
                        </filter>
                    </defs>
                  </svg>

                  <Button variant="contained" onClick={getFilteredData} style={{backgroundColor:'#ebedf9',color:'grey'}}>
                    {!loading ? (
                          "فلترة"
                        ) : (
                          <div className="spinner-border " role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                  </Button>

                </div>
              </div>
            </div>
           
            <div
              className={`FormContainer  ${
                props.inactive === false ? "activeSideMenu" : ""
              }`}
              style={{
                height: "calc(100% - 9em)",
                minHeight: 600,
                borderRadius: 10,
              }}
            >
            
              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={incomeTaxReports?.total ? incomeTaxReports?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize);
                }}
                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params);
                }}
              />
              <Box width="45%" m="auto" sx={{ marginTop: "10px" }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={incomeTaxReportNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p);
                  }}
                />
              </Box>

              <div
                style={{
                  width: "50%",
                  position: "absolute",
                  top: "100px",
                  margin: "0 auto",
                  left: "50%",
                  top: "50%",
                }}
              >
                {loading && <CircularIndeterminate />}
              </div>
            </div>

          </div>

          {/* <SideMenu inactive={inactive} setInactiveFromProps={setInactive} /> */}
        </div>
      </div>

      {selectedObject&&
        <FullScreenDialog
          handleSaveClicked={() => { setshowBoxOfViewForm(false) }}
          title={"عرض حالة و تفاصيل التقرير"}
          children={<ViewIncomeTaxReport render={render} setRender={setRender} object={selectedObject} setOpen={()=>setshowBoxOfViewForm(false)} advanceSearch={()=>advanceSearch()} />}
          open={showBoxOfViewForm}
          setOpen={()=>setshowBoxOfViewForm(false)}
          activeShadow={true}
          //  setReloadData={setReloadData} 
        />}

      {/* <Modal
        keepMounted
        open={showBoxOfEditForm || showBoxOfViewForm}
      
        onClose={() => {
          setshowBoxOfEditForm(false);
          setshowBoxOfViewForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
      
          className="modalCroupsCarrier"
        >
          {selectedObject && showBoxOfEditForm && (
            <UpdateIncomeTaxReport object={selectedObject} />
          )}
          {selectedObject && showBoxOfViewForm && (
            <ViewIncomeTaxReport object={selectedObject} />
          )}
        </Box>
      </Modal> */}
    </div>
  );
}
